const type = 'advanced'
const path = '/advance/angular-node/angular/src/app/'
const name = 'app.component.ts'

export { type, path, name }
